import apiClient from './apiClient';

export const moduleService = {
  async getModules() {
    const response = await apiClient.get('/modules');
    return response.data;
  },

  async getModule(moduleId) {
    const response = await apiClient.get(`/modules/${moduleId}`);
    return response.data;
  },

  async getModuleStatus(moduleId) {
    const response = await apiClient.get(`/modules/${moduleId}/status`);
    return response.data;
  },

  async getAllModulesStatus() {
    const response = await apiClient.get('/modules/status');
    return response.data;
  }
};

export default moduleService;
